module.exports = {
      id: "illustrations:01B-usage",
      viewBox: "0 0 439 78",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:01B-usage",
      toString: function () {
        return this.url;
      }
    }